var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"back",on:{"click":_vm.click}},[_c('IconBack')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }